export default "__VITE_ASSET__DuQU0YdI__"